import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobsMetricsTimeseriesResponse } from "@/types";

export function useGetJobsMetricsTimeseries() {
  return useQuery({
    queryKey: ["metrics/scraped-jobs/timeseries"],
    queryFn: async () => {
      const path = "metrics/scraped-jobs/timeseries";
      const res = await guacHttpClient.get<
        JobsMetricsTimeseriesResponse,
        HttpResponse<JobsMetricsTimeseriesResponse>
      >(path);

      return res.data;
    },
    // this value doesnt change often so we can cache for a long time
    staleTime: 1000 * 60 * 60 * 12, // 12 hours
    select: (data: JobsMetricsTimeseriesResponse) => {
      // spread data into an array and sort by date
      return [...data]
        .sort((a, b) => a.date.localeCompare(b.date))
        .map((entry) => ({
          ...entry,
          date: new Date(entry.date).toLocaleDateString("en-CA"), // "en-CA" gives YYYY-MM-DD in local time
        }));
    },
  });
}
